// extracted by mini-css-extract-plugin
export default {"container":"components-general-modal-filter-bar-module__container"};